/**
 * Created by Administrator on 2018-06-01.
 */
//获取cookie、
export function getCookie(name) {
  var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  if (arr = document.cookie.match(reg))
    //return (arr[2]);
    return (unescape(arr[2]));
  else
    return null;
}
 
// +";Domain=freightshop.com"
//设置cookie,增加到vue实例方便全局调用
export function setCookie (c_name, value ) {
  // var exdate = new Date();
  //exdate.setDate(exdate.getDate() + expiredays);
     var exdate = new Date();
     exdate.setTime(exdate.getTime() + (3 * 24 * 60 * 60 * 1000)); //设置有效期，3天后过期
     document.cookie = c_name + "=" + escape(value) + ";expires=" + exdate.toGMTString()+";Path=/";
};

//为了不妨碍已经用了setcookie，新增价格addcookie，选择更多  
//  增加了path选项，expiredays，有效天数
export function addCookie (c_name, value, expiredays,path) {
  var exdate = new Date();
  exdate.setDate(exdate.getDate() + expiredays);
  if(path) {
    document.cookie = c_name + "=" + escape(value) + ((expiredays == null) ? "" : ";expires=" + exdate.toGMTString()) + "; path="+path+";";
  } else {
    document.cookie = c_name + "=" + escape(value) + ((expiredays == null) ? "" : ";expires=" + exdate.toGMTString());
  }
};



//删除cookie
export function delCookie (name) {
  var exp = new Date();
  exp.setTime(exp.getTime() - 1);
  var cval = getCookie(name);
  if (cval != null)
    document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString()+";Path=/";
};

// //获取Token
// export function getToken () {
//   return localStorage.getItem("X-BY-EnTOKEN");
//   //return 'UHo4VTRmSFlldFVsRTA1QTRFM082dmpodmpOYkM3MUN5YmR2cjlPeUorcXB5KzM5dzJPa2hPS05teDU1OE5seUJDdHJkZkxWbndtL0UyWHp3a2R6Z3JETld3MVJKUS9xd0xJMURELyt5QkRaNStGL1JYZUtKdE4zeGNCcDVSdGs='
// }

// // //设置登录后的token
// export function setToken (t_value) {
//   localStorage.setItem("X-BY-EnTOKEN",t_value);
// }

// //删除token
// export function delToken () {
//   localStorage.removeItem("X-BY-EnTOKEN");
// }





// WEBPACK FOOTER //
// ./src/ask/cookiejs.js